import { Menu, ActionIcon, useMantineColorScheme } from '@mantine/core';
import { MoreVertical, FolderInput, Trash2, Info, Pencil } from 'lucide-react';
import { getBaseGlassStyles } from '../common/BaseContainer';

interface ItemActionsMenuProps {
    type: string;
    id: string;
    onMove: (type: string, id: string) => void;
    onDelete: (type: string, id: string) => void;
    onViewDetails?: (type: string, id: string) => void;
    onEdit?: (type: string, id: string) => void;
    deleteLabel?: string;
}

export const ItemActionsMenu = ({
    type,
    id,
    onMove,
    onDelete,
    onViewDetails,
    onEdit,
    deleteLabel = "Delete"
}: ItemActionsMenuProps) => {
    const { colorScheme } = useMantineColorScheme();

    return (
        <Menu position="bottom-end" shadow="md" width={160}>
            <Menu.Target>
                <ActionIcon
                    variant="subtle"
                    color="gray"
                    className="opacity-100 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity"
                >
                    <MoreVertical size={18} />
                </ActionIcon>
            </Menu.Target>

            <Menu.Dropdown style={getBaseGlassStyles(colorScheme)}>
                {onViewDetails && (
                    <Menu.Item
                        leftSection={<Info size={14} />}
                        onClick={() => onViewDetails(type, id)}
                    >
                        View Details
                    </Menu.Item>
                )}
                {onEdit && (
                    <Menu.Item
                        leftSection={<Pencil size={14} />}
                        onClick={() => onEdit(type, id)}
                    >
                        Edit
                    </Menu.Item>
                )}
                <Menu.Item
                    leftSection={<FolderInput size={14} />}
                    onClick={() => onMove(type, id)}
                >
                    Move
                </Menu.Item>
                <Menu.Item
                    leftSection={<Trash2 size={14} />}
                    color="red"
                    onClick={() => onDelete(type, id)}
                >
                    {deleteLabel}
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    );
};
